import { TableSpec, tableSpecSchema } from '@/core';
import { createVisualization } from '@/plugin-system';
import { TableColumnsSettings } from './TableColumnsSettings';
import { TableIcon } from './TableIcon';
import { TableOptionsEditorSettings } from './TableOptionsEditorSettings';
import { TablePanel } from './TablePanel';
import { TableProps } from './table-model';
import { isTableV2 } from './utils';

export const Table = createVisualization<TableProps, TableSpec>(TablePanel, {
  vizConfig: {
    noPadding: true,
  },
  dashboardConfig: {
    kind: 'Table',
    mapSpecToProps: (spec: TableSpec) => {
      return { spec };
    },
    mapPropsToSpec: (props) => props as TableSpec,
    panelOptionsEditorComponents: [
      {
        label: 'Settings',
        content: TableOptionsEditorSettings,
      },
      {
        label: 'Table columns',
        content: TableColumnsSettings,
      },
    ],
    createInitialOptions: (): TableSpec => {
      return {};
    },
    schema: tableSpecSchema,
    enableCompareMode: true,
    // The initial version of table supports 'TimeSeries' but it is now deprecated.
    supportedDataType: ['Table', 'TimeSeries'],
    mapSpecToDataType: (spec: TableSpec) => {
      return isTableV2(spec) ? 'Table' : 'TimeSeries';
    },
    queryEditorCapabilities: {
      disablePerQueryThreshold: true,
    },

    contextLinkConfig: {
      scopeName: 'Row',
      scopeVariables: ['labels.<label_name>'],
    },
    icon: TableIcon,
  },
});

export type TableVizProps = React.ComponentProps<typeof Table.Viz>;
export type TableVizBaseProps = React.ComponentProps<typeof Table.VizBase>;
